import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NotificationAddComponent from '../components/notificationAddComponent'; 
import { getRegionListFunc,insertNotificationSettings ,fetchNotificationTypes,fetchNotificationCategory,fetchFontType
     }from '../action/notificationAction';

class NotificationAddContainer extends Component {
    constructor(props) {
        super(props);
        this.insertNotificationSettings = this.insertNotificationSettings.bind(this); 
    }

    componentDidMount() {  
         this.props.actions.getRegionListFunc(
                this.props.dispatch)
        this.props.actions.fetchFontType( 
            this.props.dispatch
        ) 
               this.props.actions.fetchNotificationTypes( 
                   this.props.dispatch
               ) 
               this.props.actions.fetchNotificationCategory( 
                this.props.dispatch
            ) 
            //this.props.actions.getAllRegionSettings();
    }

    insertNotificationSettings(formData) { 
        this.props.actions.insertNotificationSettings(
            this.props.notificationSettings.isLoading,
            formData,
            this.props.dispatch
        )
        
    }
 
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row"> 
                            <NotificationAddComponent                                 
                                insertNotificationSettings={this.insertNotificationSettings} 
                                notificationSettings={this.props.notificationSettings} 
                                statusCode={this.props.notificationSettings.statusCode} 
                                //getRegionList={this.getRegionData}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            insertNotificationSettings,
            fetchNotificationTypes ,
            fetchNotificationCategory,
            fetchFontType,
              getRegionListFunc,
        }, dispatch)
    };
};

function mapStateToProps({ notificationReducer }) { 
    return {  
        notificationSettings: {
            isLoading: notificationReducer.isLoading,
            notificationType: notificationReducer.notificationType,
            notificationList: notificationReducer.notificationList,
            statusCode: notificationReducer.statusCode,
            errorMessage: notificationReducer.errorMessage,
            messageLabel: notificationReducer.messageLabel,
            notificationCategory:notificationReducer.notificationCategory,
            fontType:notificationReducer.fontType,
             regionList :notificationReducer.regionList,
        } 
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationAddContainer))